/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Odd_Misty_Buzzard_HeartInputs */

const fr_odd_misty_buzzard_heart = /** @type {(inputs: Odd_Misty_Buzzard_HeartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des séances`)
};

/**

* @param {Odd_Misty_Buzzard_HeartInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const odd_misty_buzzard_heart = /** @type {((inputs?: Odd_Misty_Buzzard_HeartInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Odd_Misty_Buzzard_HeartInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_odd_misty_buzzard_heart(inputs)
});